export const parseStaffName = (name) => {
  if (!name) return { first_name: "", last_name: "" }
  const parts = name.split(" ")
  return {
    first_name: parts[0] || "",
    last_name: parts[1] || ""
  }
}

export const getStatusConfig = (status, t) => {
  const statusConfig = {
    Active: { color: "green", text: t("staff.status.active") },
    Deactivated: { color: "red", text: t("staff.status.deactivated") }
  }

  return statusConfig[status] || { color: "default", text: status }
}

export const getRoleConfig = (role) => {
  return { color: "var(--color-primary-surface)", text: role }
}

export const createMenuItems = (staffMember, handlers, t, permissionChecker = null, userRole = null) => {
  const { onView, onEdit, onDeactivate, onActivate, onDelete } = handlers

  const allMenuItems = [
    {
      key: "view",
      label: t("staff.menu_items.view"),
      onClick: () => onView(staffMember.id),
      requiresPermission: false
    },
    {
      key: "edit",
      label: t("staff.menu_items.edit"),
      onClick: () => onEdit(staffMember.id),
      requiresPermission: true,
      permission: "edit"
    },
    {
      key: "deactivate",
      label: staffMember.status === "Active" ? t("staff.menu_items.deactivate") : t("staff.menu_items.activate"),
      onClick: () => {
        if (staffMember.status === "Active") {
          onDeactivate(staffMember)
        } else {
          onActivate(staffMember)
        }
      },
      requiresPermission: true,
      permission: "disable"
    },
    {
      key: "delete",
      label: t("staff.menu_items.delete"),
      onClick: () => onDelete(staffMember),
      danger: true,
      requiresPermission: false,
      requiresRole: true,
      allowedRole: "guide_user"
    }
  ]

  const filteredMenuItems = allMenuItems.filter((item) => {
    if (item.requiresRole) {
      return userRole === item.allowedRole
    }

    if (!permissionChecker || !item.requiresPermission) {
      return true
    }

    return permissionChecker(item.permission)
  })

  return filteredMenuItems.map(({ requiresPermission, permission, requiresRole, allowedRole, ...item }) => item)
}
